
export const fixElement = (el) => {
    if (!el) return
    el.style.overflowX = "hidden"
    el.style.position = "fixed"
}
export const unFixElement = (el) => {
    if (!el) return
    el.style.overflowX = "scroll"
    el.style.position = "static"
}

export const toggleElement = (el) => {
    if (!el) return
    if (el.style.overflowX === "scroll") fixElement(el)
    else unFixElement(el)
}